__turbopack_context__.v({
  "accordionContainer": "CommunityNavModalMainScreen-module-scss-module__2Xelcq__accordionContainer",
  "categoryLink": "CommunityNavModalMainScreen-module-scss-module__2Xelcq__categoryLink",
});
